export default "__VITE_ASSET__Bt87cwOk__"